<template>
    <v-dialog v-model="isActive" persistent max-width="450">
        <v-card>
            <v-toolbar flat dark color="error">
                <v-app-bar-nav-icon><v-icon>fas fa-exclamation-triangle</v-icon></v-app-bar-nav-icon>
                <v-toolbar-title>{{ title }}</v-toolbar-title>
            </v-toolbar>
            <v-card-text class="subtitle-1 black--text mt-3" v-html="message"/>
            <v-divider class="ma-0" v-if="!isLoading"/>
            <v-progress-linear v-if="isLoading" indeterminate color="primary" height="2" class="ma-0"/>
            <v-card-actions>
                <v-spacer/>
                <v-btn text color="error" :disabled="isLoading" :loading="isLoading" @click="$emit('confirm')">Ok</v-btn>
                <v-btn text color="primary" :disabled="isLoading" @click="$emit('update:isActive', false)">Cancel</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "ConfirmDialog",
    props: {
        isActive: {
            type: Boolean,
            default: false
        },
        isLoading: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: 'Action confirmation'
        },
        message: {
            type: String,
            default: 'Do you really want to perform this action?'
        }
    }
}
</script>

<style scoped>

</style>
